import { SearchDate } from "../infrastructure/searchDate.helper";

export class filterShipmentModel {
	shipmentNumber: string;
	shipmentNumberS: string;
	shipmentNumberW: string;
	compartmentId: any;
	senderName: string;
	senderPhone: string;
	receiverName: string;
	receiverPhone: string;
	toHubId: any;
	toDistrictId: any;
	toWardId: any;
	shippingAddress: any;
	fromDate: any;
	toDate: any;
	deliveryVehicleTypeId:any;
	typeShipmentBoxs?:any;
	pageNumber: any = 1;
	pageSize: any = 20;
}
